import { MtDriveFile } from "server/models"
import {
    SilMode,
    SilCalculationMethod,
    SilArchitecturalConstraints,
    SilFailureRateFormat,
    SilProbabilityFormat,
    SilPercentageFormat,
    YesNo,
} from "client/utils"
import { ProjectActiveModules } from "client/store"

export type ChangeUserSettings = { [settingId: string]: any }
export type DisplayColumns = { [key: string]: boolean }

export interface UserSettings {
    project: {
        defaultPublicId: string
        defaultName: string
        defaultDescription: string
        defaultLogoId: number | null
        defaultLogo: MtDriveFile | null
        defaultModules: ProjectActiveModules
    }
    sil: {
        defaultSafetyFunctionName: string
        defaultMode: SilMode
        defaultCalculationMethodDangerous: SilCalculationMethod
        defaultCalculationMethodSafe: SilCalculationMethod
        defaultArchitecturalConstraints: SilArchitecturalConstraints
        // defaultReportTemplate ----- TODO

        failureRate: SilFailureRateFormat
        failureRateDecimal: number
        probability: SilProbabilityFormat
        probabilityDecimal: number
        percentage: SilPercentageFormat
        percentageDecimal: number

        // IEC 61508:2010
        iec615082010: {
            t1: string
            mttr: string
            mrt: string
            beta: string
            betaD: string
            k: string
        }

        // IEC 61508:1998
        iec615081998: {
            t1: string
            mttr: string
            beta: string
        }

        // ISA TR84:2002
        isaTR842002: {
            t1: string
            mttr: string
            beta: string
            safeFailure: string
            dangerousFailure: string
        }

        // VDI/VDE 2180:2019
        vdivde21802019: {
            ptc0A: string
            ptc1A: string
            ptc0B: string
            ptc1B: string
            ptc0C: string
            ptc1C: string
            beta: string
            t0: string
            t1: string
            t2: string
        }

        // ISA TR84:2022
        isaTR842022: {
            ti: string
            di: string
            mttr: string
            beta: string
            safeState: YesNo
        }
    }
    system: {
        rowsPerPage: number
    }
    displayColumns: {
        compliance: DisplayColumns
        formalReviewCompliance: DisplayColumns
        reviewCompliance: DisplayColumns
        reviewReview: DisplayColumns
        requirementReview: DisplayColumns
        task: DisplayColumns
    }
}

export interface UserSettingsState {
    settings: UserSettings
    reloadList: boolean
}

export const SET_USER_SETTINGS = "SET_USER_SETTINGS"
export const UPDATE_USER_SETTINGS = "UPDATE_USER_SETTINGS"

export const USER_SETTINGS_RELOAD_LIST = "USER_SETTINGS_RELOAD_LIST"
